const API_URL = {
  CLOUD_PBX_NUMBER: "/cloud-pbx/number",
  CLOUD_PBX_NUMBER_BUSINESS: "/cloud-pbx/number-business",
  CLOUD_PBX_INBOUND_CALL: "/cloud-pbx/inbound-call",
  CLOUD_PBX_OUTBOUND_CALL: "/cloud-pbx/outbound-call",
  CLOUD_PBX_INBOUND_CALL_EXPORT: "/cloud-pbx/inbound-call",
  CLOUD_PBX_OUTBOUND_CALL_EXPORT: "/cloud-pbx/outbound-call",
  CLOUD_PBX_REPORT_IBC_OBC: "/cloud-pbx/report-ibc-obc",
  CLOUD_PBX_REPORT_IBC_OBC_EXT: "/cloud-pbx/report-ibc-obc-ext",
  CLOUD_PBX_EXTENSION: "/cloud-pbx/extension",
  OMNI_CHANNEL_CHANNEL: "/omni-channel/channel",

  VNPOST_PROVINCE: "/vnpost/province",
  DEPARTMENT_QUEUE: "/id/user/department-queue",

  USER: "/id/user",
  CHAT_INFO: "/id/user/chat-info",
};

export default API_URL;
